// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__6Bvn7","welcomeBox":"style__welcomeBox__kMSOL","menu":"style__menu__tA4i+","separate_2_buttons":"style__separate_2_buttons__24QVE"};